const stickyDirective = (app) => {
  app.directive('sticky', {
    mounted(el, binding) {
      const { offset = 0, dependentSelector = null } = binding.value || {};
      let dependentElement = null;
      let initialElementTopOffset = 0;
      const additionalScrollOffset = 30;

      const placeholder = document.createElement('div');
      placeholder.style.display = 'none';

      const calculateOffsets = () => {
        if (dependentSelector) {
          dependentElement = document.querySelector(dependentSelector);
        }
        if (initialElementTopOffset === 0) {
          initialElementTopOffset = el.getBoundingClientRect().top + document.body.scrollTop;
        }
      };

      const getNotificationBarHeight = () => {
        const value = getComputedStyle(document.documentElement).getPropertyValue('--notification-bar-height');
        return parseFloat(value) || 0;
      };

      const updateStickyState = () => {
        const scrollY = document.body.scrollTop || document.documentElement.scrollTop;
        const elementTopOffset = initialElementTopOffset;
        const notifBarHeight = getNotificationBarHeight();

        if (scrollY >= elementTopOffset + additionalScrollOffset - offset) {
          if (!el.classList.contains('sticky-visible')) {
            placeholder.style.display = 'block';
            placeholder.style.width = `${el.offsetWidth}px`;
            placeholder.style.height = `${el.offsetHeight}px`;

            el.parentNode.insertBefore(placeholder, el);

            el.classList.add('sticky-init');
            el.style.position = 'fixed';
            el.style.top = `${-el.offsetHeight}px`;
            requestAnimationFrame(() => {
              el.classList.add('sticky-visible');
              el.style.top = `${offset + notifBarHeight}px`;
            });
          } else {
            // Update top position in case notification bar height changed
            el.style.top = `${offset + notifBarHeight}px`;
          }
        } else {
          if (el.classList.contains('sticky-visible')) {
            el.classList.remove('sticky-visible');
            el.classList.remove('sticky-init');

            el.style.position = '';
            el.style.top = '';
            if (placeholder.parentNode) placeholder.remove();
            placeholder.style.display = 'none';
          }
        }
      };

      const onScroll = () => updateStickyState();
      const onResize = () => {
        calculateOffsets();
        updateStickyState();
      };

      document.body.addEventListener('scroll', onScroll);
      window.addEventListener('resize', onResize);

      calculateOffsets();
      updateStickyState();

      el._onScroll = onScroll;
      el._onResize = onResize;
      el._placeholder = placeholder;
    },
    unmounted(el) {
      document.body.removeEventListener('scroll', el._onScroll);
      window.removeEventListener('resize', el._onResize);

      if (el._placeholder && el._placeholder.parentNode) {
        el._placeholder.parentNode.removeChild(el._placeholder);
      }
    },
  });
};

export default stickyDirective;
